import cloneDeep from 'lodash/cloneDeep'
import has from 'lodash/has'
import config from 'config'

const isProd = config.isProd

const showcases = [
  {
    image: isProd
    ? 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fbg-showcase-1.jpg?alt=media&token=6e5a3aef-d50a-4498-94cf-47f8a399c257'
    : 'https://firebasestorage.googleapis.com/v0/b/whimm-test.appspot.com/o/templates%2FoutSide%2Fbg-showcase-1.jpg?alt=media&token=ac50908a-aa8f-4b48-8cae-dc9ef92f78c4',

    products: [
      {
        id: 1,
        title: 'Shoes',
        x: 10,
        y: 11,
        buttonText: 'More Options',
        iconPosition: 'right',
        details: {
          available: true,
          title: 'The Shoes',
          description: 'Returning to its original design, Out Side’s latest edition of running shoes utilizes the newest, lightest, and most comfortable material.',
          price: 99,
          images: [ isProd
            ? 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-shoes-black.jpg?alt=media&token=e5b30441-421a-4ae7-9904-7dc9f9a1c761'
            : 'https://firebasestorage.googleapis.com/v0/b/whimm-test.appspot.com/o/templates%2FoutSide%2Fproduct-shoes-black.jpg?alt=media&token=1daff9ff-91b2-4e7a-80dd-6784f96640a6'
            // 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-shoes-pink.jpg?alt=media&token=315ab5ec-f26f-4eff-bc1a-16ae4538a1c4',
            // 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-shoes-black.jpg?alt=media&token=e5b30441-421a-4ae7-9904-7dc9f9a1c761'
          ],
          checkoutUrl: ''
        }
      },
      {
        id: 2,
        title: 'Jacket',
        x: 38,
        y: -1,
        buttonText: 'More Options',
        iconPosition: 'left',
        details: {
          available: true,
          title: 'The Jacket',
          description: 'This lightweight alive zip-up running jacket is the ultimate workout accessory. With its relaxed fit and stretchy fabric you will be able to move around freely without feeling constrained.',
          price: 40,
          images: [ isProd
            ? 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-jacket-black.jpg?alt=media&token=89e99ec3-063b-4c94-99cd-127797258969'
            : 'https://firebasestorage.googleapis.com/v0/b/whimm-test.appspot.com/o/templates%2FoutSide%2Fproduct-jacket-black.jpg?alt=media&token=18cb1257-61fa-4dbc-934d-28c2c8691fb2'
            // 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-jacket-gray.jpg?alt=media&token=85afecc5-114e-4347-bc18-c3b809703cc3',
            // 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-jacket-blue.jpg?alt=media&token=0a80e5dc-7b71-4d19-8fec-6deb08864a4a'
          ],
          checkoutUrl: ''
        }
      }
    ]
  },
  {
    image: isProd
    ? 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fbg-showcase-2.jpg?alt=media&token=e4e1d60a-341d-4007-9245-3dec13aba49e'
    : 'https://firebasestorage.googleapis.com/v0/b/whimm-test.appspot.com/o/templates%2FoutSide%2Fbg-showcase-2.jpg?alt=media&token=f0f3c6a8-a023-4f08-bc00-5f07b6a9de38',
    products: [
      {
        id: 3,
        title: 'Wrist Fit',
        x: 38,
        y: 2,
        buttonText: 'More Options',
        iconPosition: 'left',
        details: {
          available: true,
          title: 'The Wrist Fit',
          description: 'Make every beat count with this Wrist Fit - a high performance wristband with automatic, continuous heart rate and activity tracking right at your fingertips.',
          price: 25,
          images: [ isProd
            ? 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-wrist-fit-blue.jpg?alt=media&token=864e26c4-f393-47c6-a5af-090d27c45922'
            : 'https://firebasestorage.googleapis.com/v0/b/whimm-test.appspot.com/o/templates%2FoutSide%2Fproduct-wrist-fit-blue.jpg?alt=media&token=9bdb8b2e-9cd0-4fd6-88ae-aa1dc30029d5'
            // 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-wrist-fit-pink.jpg?alt=media&token=77cc5ad2-99a6-4739-a98c-cbbe5bb4cc9c',
            // 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-wrist-fit-yellow.jpg?alt=media&token=c689199a-b668-4a2a-8380-9f154675c668'
          ],
          checkoutUrl: ''
        }
      },
      {
        id: 4,
        title: 'Tank',
        x: 36,
        y: 20,
        buttonText: 'More Options',
        iconPosition: 'left',
        details: {
          available: true,
          title: 'The Tank',
          description: 'This essential sport racerback tank top will bring performance and comfort to your workout with a design and construction geared towards helping you move freely and easily.',
          price: 45,
          images: [ isProd
            ? 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-tank-yellow.jpg?alt=media&token=482289bf-ee1b-47ba-9577-570991b0e6cc'
            : 'https://firebasestorage.googleapis.com/v0/b/whimm-test.appspot.com/o/templates%2FoutSide%2Fproduct-tank-yellow.jpg?alt=media&token=b536ff2f-d44c-4147-8ead-8b0aa8cb50fd'
            // 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-tank-gray.jpg?alt=media&token=9374856a-437c-40ee-b293-bf38f5160767'
          ],
          checkoutUrl: ''
        }
      }
    ]
  },
  {
    image: isProd
    ? 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fbg-showcase-3.jpg?alt=media&token=cc3d3735-839c-44de-8259-29bdc5b65feb'
    : 'https://firebasestorage.googleapis.com/v0/b/whimm-test.appspot.com/o/templates%2FoutSide%2Fbg-showcase-3.jpg?alt=media&token=cf9250c7-2240-4987-ab9b-9042047482b2',
    products: [
      {
        id: 5,
        title: 'Bra',
        x: 16,
        y: -11,
        buttonText: 'More Options',
        iconPosition: 'left',
        details: {
          available: true,
          title: 'The Bra',
          description: 'This Out Side’s Bra Top was designed to deliver unbelievable athletic performance. Made for mid-impact activities, this super-snug, classic-fitting sports bra is perfect for anything.',
          price: 52,
          images: [ isProd
            ? 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-bra-black.jpg?alt=media&token=ade485c0-fe87-4f2c-adc6-a0950fc3044b'
            : 'https://firebasestorage.googleapis.com/v0/b/whimm-test.appspot.com/o/templates%2FoutSide%2Fproduct-bra-black.jpg?alt=media&token=b81e0491-4fb0-4741-a009-1b2768ba35c4'
            // 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-bra-gray.jpg?alt=media&token=cc796ec4-b4fc-43f5-9b88-953b4de8fe92',
            // 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-bra-pink.jpg?alt=media&token=c1340385-3955-4c7a-a0d8-542b3108cc88',
            // 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-bra-blue.jpg?alt=media&token=97d096b3-52c3-4914-bf17-04c799a9e96b',
            // 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-bra-yellow.jpg?alt=media&token=a69e6cf0-c1f3-43d2-b9e3-920ea7a952ee'
          ],
          checkoutUrl: ''
        }
      },
      {
        id: 6,
        title: 'Leggings',
        x: 32,
        y: 9,
        buttonText: 'More Options',
        iconPosition: 'right',
        details: {
          available: true,
          title: 'The Leggings',
          description: 'Expertly crafted with a sweat wicking, double-faced fabric, Out Side’s core leggings feature built-in contour briefs that streamline the body and come in full, cropped, and capri leg lengths.',
          price: 30,
          images: [ isProd
            ? 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-leggings-black.jpg?alt=media&token=19e453b1-23cc-44f8-b979-3a4d5efd11eb'
            : 'https://firebasestorage.googleapis.com/v0/b/whimm-test.appspot.com/o/templates%2FoutSide%2Fproduct-leggings-black.jpg?alt=media&token=f9836a98-d41d-4304-87ef-fd64f852290b'
            // 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-leggings-gray.jpg?alt=media&token=c0f20175-8ebe-4a87-b7c8-9f2d1187473c',
            // 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-leggings-red.jpg?alt=media&token=940dfa80-821e-4dbb-8c81-8b22afdb4462',
            // 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-leggings-blue.jpg?alt=media&token=b240db1f-6b90-4b16-ad0e-c9618cb46513',
            // 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fproduct-leggings-yellow.jpg?alt=media&token=a4744b40-ad4b-4e1b-bcff-87bd13e9fcfc'
          ],
          checkoutUrl: ''
        }
      }
    ]
  }
]

const staticScenes = {
  splash: {
    title: 'Lookbook: Out Side',
    logo: isProd
    ? 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Flogo.png?alt=media&token=2edd9923-fe23-43ae-9f35-b9568803f059'
    : 'https://firebasestorage.googleapis.com/v0/b/whimm-test.appspot.com/o/templates%2FoutSide%2Flogo.png?alt=media&token=b58a1755-9caf-4c4a-8885-45cd1e46853d'
  },
  intro: {
    image: isProd
    ? 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fbg-intro-lw.jpg?alt=media&token=05bfbdca-2cb4-46a3-95ee-7dfa69d77310'
    : 'https://firebasestorage.googleapis.com/v0/b/whimm-test.appspot.com/o/templates%2FoutSide%2Fbg-intro-lw.jpg?alt=media&token=49e0cb25-d736-4869-9509-4def65eed096',
    line1: 'High Performance',
    line2: 'Timeless Styles With',
    line3: 'Fashion-led Activewear'
  },
  door: {
    buttonCaption: 'View Collection',
    video: {
      url: isProd
      ? 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fsmall.mp4?alt=media&token=13cde3b8-2f76-4676-90bb-7d0d84e81622'
      : 'https://firebasestorage.googleapis.com/v0/b/whimm-test.appspot.com/o/templates%2FoutSide%2Fsmall.mp4?alt=media&token=e124169d-e378-4652-8a14-ae18a72b2239',
      thumbUrl: isProd
      ? 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fposter.jpg?alt=media&token=edf48783-51f5-4d26-8184-68b4543cdea3'
      : 'https://firebasestorage.googleapis.com/v0/b/whimm-test.appspot.com/o/templates%2FoutSide%2Fposter.jpg?alt=media&token=0fb565f7-7a7d-488c-9a46-cc5d840704f8',
      isTappable: false
    }
  },
  lastScene: {
    image: isProd
    ? 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FoutSide%2Fbg-showcase-4.jpg?alt=media&token=c56f738b-f264-4ae0-8ec4-3a552bf161f5'
    : 'https://firebasestorage.googleapis.com/v0/b/whimm-test.appspot.com/o/templates%2FoutSide%2Fbg-showcase-4.jpg?alt=media&token=65ef30f9-f0cd-42f3-b8af-1088d0b2c1cd',
    title: '“The Outdoors Made Me Who I Am.”',
    subtitle: 'Where is your outside?',
    author: 'Jaqieline Walker',
    social: {
      facebook: 'https://facebook.com',
      twitter: 'https://twitter.com',
      email: 'your@email.address',
      phone: '+123456789'
    },
    shareTitle: 'Share',
    shareSubtitle: 'with friends'
  },
  appSettings: {
    title: 'Instant App',
    integration: null,
    googleAnalyticsId: null
  }
}

function createShowcase (num) {
  const res = cloneDeep(showcases[0])
  res.products[0].id = num * 2 + 1
  res.products[1].id = num * 2 + 2
  return res
}

function showcaseByNum (i) {
  if (showcases[i]) {
    return showcases[i]
  } else {
    return createShowcase(i)
  }
}

function reallyCreateSettings (slidesCnt) {
  let res = {...staticScenes}
  const showcases = []
  for (let i = 0; i < slidesCnt; i++) {
    showcases.push(showcaseByNum(i))
  }
  // showcases.push(lastShowCase)
  res.showcases = showcases
  return res
}

const cache = {}

export function createSettings (slidesCnt) {
  if (has(cache, slidesCnt)) {
    // console.log('settings from cache', slidesCnt)
    return (cache[slidesCnt])
  } else {
    // console.log('settings was created', slidesCnt)
    const res = reallyCreateSettings(slidesCnt)
    cache[slidesCnt] = res
    return res
  }
}



// WEBPACK FOOTER //
// ./src/templates/outSide/template/settings.js